import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AdminLayout } from '@/components/layout/AdminLayout';
import { AdminLogin } from '@/components/auth/AdminLogin';
import { DashboardPage } from '@/pages/admin/DashboardPage';
import { BatchListPage } from '@/pages/admin/BatchListPage';
import { BatchCreatePage } from '@/pages/admin/BatchCreatePage';
import { SearchPage } from '@/pages/admin/SearchPage';
import { UserManagementPage } from '@/pages/admin/UserManagementPage';
import { SettingsPage } from '@/pages/admin/SettingsPage';
import { cognitoAuth } from '@/services/cognitoAuth';

export const AdminPortal: React.FC = () => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);

  useEffect(() => {
    // Check authentication status on mount
    const checkAuth = () => {
      const authenticated = cognitoAuth.isAuthenticated();
      setIsAuthenticated(authenticated);
    };

    checkAuth();

    // Set up periodic auth check (in case tokens expire)
    const interval = setInterval(checkAuth, 30000); // Check every 30 seconds

    return () => clearInterval(interval);
  }, []);

  const handleLoginSuccess = () => {
    setIsAuthenticated(true);
  };

  // Show loading state while checking authentication
  if (isAuthenticated === null) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-slate-900"></div>
      </div>
    );
  }

  // Show login form if not authenticated
  if (!isAuthenticated) {
    return <AdminLogin onLoginSuccess={handleLoginSuccess} />;
  }

  // Show admin portal if authenticated
  return (
    <AdminLayout>
      <Routes>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/batches" element={<BatchListPage />} />
        <Route path="/batches/new" element={<BatchCreatePage />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/users" element={<UserManagementPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Routes>
    </AdminLayout>
  );
};